import {
  GetTmpMemberQuery,
  GetTmpMemberDocument,
  OperationInput,
  ListTmpMemberQuery,
  ListTmpMemberDocument,
  TmpMemberListInput,
  TmpMemberCountInput,
  GetTmpMemberCountQuery,
  GetTmpMemberCountDocument,
} from "@/generated/graphql";
import { ApolloQueryResult } from "apollo-client";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 仮会員情報を取得する
 * @param tmpMemberId: 仮会員ID
 * @param operationInput: 操作ログInput
 * @returns 会員情報
 */
export async function getTmpMember(
  tmpMemberId: string,
  operationInput: OperationInput
): Promise<
  | {
      __typename?: "TmpMember";
      address1: string;
      address2: string;
      address3?: string | null | undefined;
      name1: string;
      name2: string;
      name_kana1: string;
      name_kana2: string;
      zip_code: string;
      phone: string;
      shop_code?: string | null | undefined;
    }
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const tmpMember: ApolloQueryResult<GetTmpMemberQuery> =
      await apolloClient.query<GetTmpMemberQuery>({
        query: GetTmpMemberDocument,
        variables: {
          logInput: operationInput,
          tmp_member_id: tmpMemberId,
        },
        fetchPolicy: "no-cache",
      });
    return tmpMember.data.getTmpMember;
  } catch (err: any) {
    err.message = "仮会員情報の取得に失敗しました。";
    throw err;
  }
}

/**
 * 仮会員情報一覧を取得する
 * @param tmpMemberListInput: 仮会員情報
 * @param operationInput: 操作ログInput
 * @returns 仮会員一覧
 */
export async function listTmpMember(
  tmpMemberListInput: TmpMemberListInput,
  operationInput: OperationInput
): Promise<
  | Array<
      | {
          __typename?: "TmpMember";
          tmp_member_id: string;
          name1: string;
          name2: string;
          name_kana1: string;
          name_kana2: string;
          zip_code: string;
          address1: string;
          address2: string;
          address3?: string | null | undefined;
          phone: string;
          is_deliverable: number;
        }
      | null
      | undefined
    >
  | null
  | undefined
> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();

    const tmpMember: ApolloQueryResult<ListTmpMemberQuery> =
      await apolloClient.query<ListTmpMemberQuery>({
        query: ListTmpMemberDocument,
        variables: {
          logInput: operationInput,
          input: tmpMemberListInput,
        },
        fetchPolicy: "no-cache",
      });
    return tmpMember.data.listTmpMember;
  } catch (err: any) {
    err.message = "仮会員一覧の取得に失敗しました。";
    throw err;
  }
}

/**
 * 仮会員情報一覧の件数を取得する
 * @param tmpMemberCountInput: 仮会員情報
 * @returns 件数
 */
export async function getTmpMemberCount(
  tmpMemberCountInput: TmpMemberCountInput
): Promise<number> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const tmpMember: ApolloQueryResult<GetTmpMemberCountQuery> =
      await apolloClient.query<GetTmpMemberCountQuery>({
        query: GetTmpMemberCountDocument,
        variables: {
          input: tmpMemberCountInput,
        },
        fetchPolicy: "no-cache",
      });

    return tmpMember.data.getTmpMemberCount!.count;
  } catch (err: any) {
    err.message = "仮会員一覧の件数取得に失敗しました。";
    throw err;
  }
}
